module.exports = __webpack_public_path__ + "media/images/application2/AppMfaIdentityVerification__dl__item--1-81ae1f5a4e0e3d4d8850754b535f970b.svg";